var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6667 9.33334C10.6667 9.88561 11.1144 10.3333 11.6667 10.3333C12.219 10.3333 12.6667 9.88561 12.6667 9.33334C12.6667 8.78108 12.219 8.33334 11.6667 8.33334C11.1144 8.33334 10.6667 8.78108 10.6667 9.33334Z",
    stroke: "#070E10",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66665 4.66667H10.6666C12.5522 4.66667 13.495 4.66667 14.0808 5.25245C14.6666 5.83824 14.6666 6.78107 14.6666 8.66667V10C14.6666 11.8856 14.6666 12.8284 14.0808 13.4142C13.495 14 12.5522 14 10.6666 14H6.66665C4.15249 14 2.89541 14 2.11436 13.2189C1.33331 12.4379 1.33331 11.1808 1.33331 8.66667V7.33333C1.33331 4.81917 1.33331 3.5621 2.11436 2.78105C2.89541 2 4.15249 2 6.66665 2H9.33331C9.95331 2 10.2633 2 10.5176 2.06815C11.2078 2.25308 11.7469 2.79218 11.9318 3.48236C12 3.73669 12 4.04669 12 4.66667",
    stroke: "#070E10",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.dd2935236696770fca1aebb76eb6508b.svg";
export { ForwardRef as ReactComponent };